<template>
  <div class="bg-gradient-primary">
    <div class="container">
      <br>

      <div class="card o-hidden border-0 shadow-lg">
        <div class="card-body p-0">
          <div class="row" style="min-height: 60vh">
            <div class="col-lg-5 d-none d-lg-block bg-register-image"></div>
            <div class="col-lg-7 my-auto">
              <div class="p-4">
                <div class="text-center">
                  <img class="logo mx-1 my-1" src="@/assets/lion.png"/>
                  <h4 class="mb-sm-2 mb-md-4">Sagt Tschüss!</h4>
                </div>
                <br>
                <div class="text-center">
                  <h5>Ihr Account wurde gelöscht.</h5>
                  <br> <br> <br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>

<style>

</style>
